import React, { Component } from 'react'
import { pxToRem, color } from '../../utils'
import styled from 'styled-components'

const WrapperHeader = styled.header`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${({ margin }) => pxToRem(margin || 35)};
  h1,
  h2,
  strong {
    margin: 0;
    padding: 0;
  }
  h2 {
    font-size: ${pxToRem(16)};
    font-style: italic;
    margin-top: ${pxToRem(5)};
  }
  h1 {
    font-size: ${pxToRem(21)};
  }
  strong {
    font-size: ${pxToRem(19)};
  }

  div:last-child {
    text-align: left;
    span {
      text-transform: capitalize;
      display: block;
      color: ${color.secondary};
      margin-top: ${pxToRem(5)};
      font-size: ${pxToRem(18)};
    }
  }

  @media only screen and (max-width: 700px) {
    h2 {
      font-size: ${pxToRem(13)};
    }
    h1 {
      font-size: ${pxToRem(17)};
    }
    strong {
      font-size: ${pxToRem(15)};
    }
  }

  @media only screen and (max-width: 550px) {
    flex-direction: column;
    div:last-child {
      text-align: left;
      margin-top: ${pxToRem(20)};
    }
  }
`

class ContentHeader extends Component {
  render() {
    const {
      title, subtitle, last_update, margin
    } = this.props

    return (
      <WrapperHeader
        margin={margin}
      >
        <div>
          <h1>{title}</h1>
          {subtitle && (<h2>{subtitle}</h2>)}
        </div>
        {last_update && (
          <div>
            <strong>Atualizado em:</strong>
            <span>
              {last_update}
            </span>
          </div>
        )}
      </WrapperHeader>
    )
  }
}

export default ContentHeader



// WEBPACK FOOTER //
// ./src/components/ContentHeader/ContentHeader.js